<div class="p-fluid p-formgrid grid tw-m-0 tw-gap-4">
  <div class="field">
    <label htmlFor="id">If selected option(s) are</label>
    <p-listbox class="fixed-size-list" [options]="options" [(ngModel)]="value.ChoiceOptionIds" optionLabel="Name" optionValue="Id"
      [multiple]="true" [checkbox]="true" [showToggleAll]="false" (ngModelChange)="valueChanged()"></p-listbox>
  </div>

  <!-- <div class="field">
    <label htmlFor="visible">Just Visible (Just InVisible if not checked)</label>
    <p-checkbox binary="true" id="visible" [(ngModel)]="value.IsVisible" (ngModelChange)="valueChanged()"></p-checkbox>
  </div> -->

</div>